<template>
  <div class="rules nlp-rules">
    <v-tabs v-model="activeTab" color="third" dark slider-color="gray" centered>
      <v-tab href="#tab-1"> Intents </v-tab>
      <v-tab href="#tab-2"> Entities </v-tab>
      <v-tab-item value="tab-1" class="pt-5">
        <v-layout row wrap>
          <v-flex md6 sm12>
            <h4 class="heading font-weight-regular mb-3 user-intent">
              If User Says Something Similar To :
            </h4>
            <v-combobox
              v-model="rule.terms"
              :items="[]"
              chips
              outline
              solo
              multiple
              @change="normalizeTerms"
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="removeTerm(data.item)"
                >
                  <strong>{{ data.item }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
          <v-flex md6 sm12>
            <div
              v-for="(replay, index) in rule.replay"
              class="replay"
              :key="index"
            >
              <replay :replay="replay" :blocks="blocks"></replay>
              <v-btn
                v-if="index > 0"
                @click="deleteReplay(index)"
                class="delete-replay"
                fab
                small
                color=""
                ><v-icon color="#666">delete_outline</v-icon></v-btn
              >
            </div>

            <v-btn
              class="add-random-replay font-weight-bold"
              color="third"
              round
              @click="addNewReplay"
              ><v-icon>add</v-icon> Add Another Answer</v-btn
            >
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item value="tab-2" class="pt-5">
        <entities
          :entities="rule.replay[0].entities"
          @updateEntities="updateEntities"
        ></entities>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import _ from "lodash";
import entities from "./entities";
import replay from "./replays";
export default {
  name: "rules",
  props: {
    rule: {
      type: Object,
      default: () => {
        return {};
      },
    },
    blocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: () => {
        return "rules";
      },
    },
  },
  components: {
    replay,
    entities,
  },
  data() {
    return {
      initRule: {},
      multiReplay: false,
      activeTab: 1,
    };
  },
  beforeMount() {
    this.initRule = _.cloneDeep(this.rule);
    this.multiReplay = this.rule.replay.length > 1;
  },
  mounted() {},
  methods: {
    async updateRule() {
      let st = _.isEqual(this.rule, this.initRule);
      this.$store.dispatch("setLoader", true);
      if (!st && this.rule.terms && this.rule.terms.length) {
        this.$store.dispatch("setSavingStatus", true);
        await this.$http.put(`/${this.type}/${this.rule.id}`, this.rule);

        this.initRule = _.cloneDeep(this.rule);
        this.$store.dispatch("setSavingStatus", false);
        this.$store.dispatch("setLoader", false);
      } else {
        this.$store.dispatch("setSavingStatus", false);
        this.$store.dispatch("setLoader", false);
      }
    },
    removeTerm(term) {
      let index = this.rule.terms.indexOf(term);
      this.rule.terms.splice(index, 1);
    },
    multiReplayUpdate() {
      if (this.multiReplay === false) {
        this.rule.replay.splice(1);
      }
    },
    addNewReplay() {
      this.rule.replay.push({
        blocks: [],
        errorOrEmpty: 0,
        text: "",
        type: "text",
      });
    },
    deleteReplay(index) {
      this.rule.replay.splice(index, 1);
    },
    normalizeTerms(terms) {
      terms[terms.length - 1] = terms[terms.length - 1].toLowerCase();
    },
    updateEntities(entities) {
      for (let i = 0; i < this.rule.replay.length; i++) {
        this.rule.replay[i].entities = entities;
        if (
          this.rule.replay[i].entities &&
          this.rule.replay[i].entities.length
        ) {
          this.rule.replay[i].hasEntity = "true";
        } else {
          this.rule.replay[i].hasEntity = "false";
        }
        this.updateRule();
      }
    },
  },
  watch: {
    rule: {
      handler() {
        this.updateRule();
        this.multiReplay = this.rule.replay.length > 1;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
